<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Záradékok</ion-title>
    <ion-buttons slot="end">
      <!-- A záradék-sablonok összevetése a 20/2012. EMMI r. 1. mellékletével (zaradek-lefedettseg.component). -->
      <ion-button (click)="lefedettseg()" fill="clear" color="light" title="Záradék-sablonok és az 1. melléklet">
        <ion-icon slot="start" name="library-outline"></ion-icon>1. melléklet
      </ion-button>
      <ion-button (click)="bezar()" fill="solid" color="light" shape="round">Bezár</ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar color="primary" *ngIf="tanuloNev">
    <ion-title size="small" style="font-size:14px">{{ tanuloNev }} <span *ngIf="oktazon">({{ oktazon }})</span></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-progress-bar type="indeterminate" *ngIf="betoltes"></ion-progress-bar>

  <!-- Meglévő záradékok -->
  <div style="display:flex;justify-content:space-between;align-items:center;gap:8px;flex-wrap:wrap">
    <h3 style="margin:0">Felvett záradékok ({{ aktivDb }})</h3>
    <ion-button size="small" fill="clear" color="medium" (click)="toroltekValt()">
      <ion-icon slot="start" [name]="toroltekIs ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
      {{ toroltekIs ? 'Töröltek elrejtése' : 'Töröltek mutatása' }}
    </ion-button>
  </div>
  <div *ngIf="!betoltes && zaradekok.length === 0" style="color:#888;padding:8px 0">
    Még nincs felvett záradék ehhez a tanulóhoz.
  </div>

  <ion-card *ngFor="let z of zaradekok" [color]="szerkesztettId === z.id ? 'light' : undefined"
            [style.opacity]="+z.torolve ? 0.6 : 1">
    <ion-card-content>
      <div style="display:flex;justify-content:space-between;align-items:center;gap:8px;margin-bottom:6px">
        <div>
          <ion-badge color="danger" *ngIf="+z.torolve" style="margin-right:6px">Törölve</ion-badge>
          <ion-badge color="dark" *ngIf="z.melleklet_kod" style="margin-right:6px"
                     title="20/2012. EMMI rendelet 1. melléklet szerinti záradék">{{ z.melleklet_kod }}</ion-badge>
          <ion-badge color="medium">{{ z.datum || '—' }}</ion-badge>
          <ion-badge color="tertiary" style="margin-left:6px">{{ megjelenesLabel(z.megjelenes_helye) }}</ion-badge>
          <ion-badge color="success" style="margin-left:6px" *ngIf="z.kategoria">{{ kategoriaNev(z.kategoria) }}</ion-badge>
        </div>
        <div>
          <ion-button size="small" fill="clear" color="medium" (click)="elozmenyValt(z)" title="Előzmény">
            <ion-icon slot="icon-only" name="time-outline"></ion-icon>
          </ion-button>
          <ng-container *ngIf="!+z.torolve">
            <ion-button size="small" fill="clear" (click)="szerkeszt(z)">
              <ion-icon slot="icon-only" name="create-outline"></ion-icon>
            </ion-button>
            <ion-button size="small" fill="clear" color="danger" (click)="torol(z)">
              <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
            </ion-button>
          </ng-container>
        </div>
      </div>
      <div style="white-space:pre-wrap" [style.text-decoration]="+z.torolve ? 'line-through' : null">{{ z.szoveg }}</div>
      <div style="font-size:12px;color:#888;margin-top:4px">
        <span *ngIf="z.letrehozta">Beírta: {{ z.letrehozta }}</span>
        <span *ngIf="z.modositotta"> · utoljára módosította: {{ z.modositotta }}</span>
        <span *ngIf="+z.torolve"> · törölte: {{ z.torolte || '—' }}, {{ z.torolve_mikor || '' }} – {{ z.torles_oka }}</span>
      </div>

      <!-- Előzmény (változásnapló) -->
      <div *ngIf="elozmenyNyitva[z.id]" style="margin-top:8px;border-top:1px solid #ddd;padding-top:6px">
        <ion-progress-bar type="indeterminate" *ngIf="elozmeny[z.id] === null"></ion-progress-bar>
        <div *ngIf="elozmeny[z.id]?.length === 0" style="color:#888;font-size:13px">
          Nincs rögzített előzmény (a napló bevezetése előtt felvett záradék).
        </div>
        <div *ngFor="let n of elozmeny[z.id] || []" style="font-size:13px;margin-bottom:6px">
          <b>{{ n.mikor }}</b> – {{ muveletNev(n.muvelet) }} – {{ n.ki_nev || n.ki || 'ismeretlen' }}
          <div *ngIf="n.muvelet === 'torles'" style="color:#a33">Ok: {{ n.ok || '—' }}</div>
          <div *ngFor="let v of n.valt" style="margin-left:12px;white-space:pre-wrap">
            {{ v.mezo }}: <span style="text-decoration:line-through;color:#a33">{{ v.elotte }}</span>
            → <span style="color:#2a7">{{ v.utana }}</span>
          </div>
        </div>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- Felvétel / szerkesztés űrlap -->
  <ion-card>
    <ion-card-header>
      <ion-card-title style="font-size:16px">
        {{ szerkesztettId ? 'Záradék módosítása' : 'Új záradék felvétele' }}
      </ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-item>
        <ion-label position="stacked">Sablonból (opcionális)</ion-label>
        <ion-select [(ngModel)]="valasztottSablonId" (ionChange)="sablonValaszt($event.detail.value)"
                    interface="popover" placeholder="Válassz kész záradékot…">
          <ion-select-option *ngFor="let s of sablonok" [value]="s.id">{{ sablonFelirat(s) }}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-note *ngIf="valasztottSablon?.melleklet_kod" style="display:block;padding:4px 16px;font-size:12px">
        20/2012. EMMI r. 1. melléklet, {{ valasztottSablon.melleklet_kod }}
        <span *ngIf="valasztottSablon.dokumentumok"> · alkalmazható: {{ dokumentumokNev(valasztottSablon.dokumentumok) }}</span>
        <span *ngIf="valasztottSablon.megjegyzes"> · {{ valasztottSablon.megjegyzes }}</span>
      </ion-note>
      <ion-item *ngIf="urlap.kategoria">
        <ion-label position="stacked">Kategória</ion-label>
        <ion-select [(ngModel)]="urlap.kategoria" interface="popover">
          <ion-select-option value="">(nincs)</ion-select-option>
          <ion-select-option value="tovabbhaladas">Nevelőtestületi határozat (továbbhaladás)</ion-select-option>
          <ion-select-option value="jogviszony">Jogviszony</ion-select-option>
          <ion-select-option value="mentesites">Mentesítés / vizsga</ion-select-option>
          <ion-select-option value="egyeb">Egyéb</ion-select-option>
          <ion-select-option value="kollegium">Kollégium</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">Dátum</ion-label>
        <ion-input type="date" [(ngModel)]="urlap.datum"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">Megjelenés helye</ion-label>
        <ion-select [(ngModel)]="urlap.megjelenes_helye" interface="popover">
          <ion-select-option *ngFor="let o of megjelenesOpciok" [value]="o.value">{{ o.label }}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">Záradék szövege</ion-label>
        <ion-textarea [(ngModel)]="urlap.szoveg" [autoGrow]="true" rows="3" placeholder="A záradék szövege…"></ion-textarea>
      </ion-item>

      <div style="display:flex;gap:8px;margin-top:12px">
        <ion-button color="success" (click)="ment()" [disabled]="mentes || !urlap.szoveg?.trim()">
          <ion-icon slot="start" name="save-outline"></ion-icon>
          {{ szerkesztettId ? 'Módosítás mentése' : 'Felvétel' }}
        </ion-button>
        <ion-button *ngIf="szerkesztettId" fill="outline" color="medium" (click)="ujUrlap()">Mégse</ion-button>
      </div>
    </ion-card-content>
  </ion-card>
</ion-content>
